import React, { useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { useDispatch, useSelector } from "react-redux";
import { getTranscationAmountAnalystics } from "../../../../../redux/action/analystics";
import AmountCreditedChart from "../children/AmountCreditedChart";
import AmountDebitedChart from "../children/AmountDebitedChart";

function TransactionChart() {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const { analystics, loadings } = useSelector(
    (state) => state?.transcationAnalystics
  );
  useEffect(() => {
    dispatch(getTranscationAmountAnalystics());
  }, [dispatch]);

  return (
    <div className={`flex gap-1 ${isMobile && "column"}`}>
      <AmountCreditedChart
        loadings={loadings}
        creditRecord={analystics?.amountCredited}
      />
      <AmountDebitedChart
        loadings={loadings}
        debitRecord={analystics.amountDebited}
      />
    </div>
  );
}

export default TransactionChart;
